import { DataTableFeatures } from "@/types/dataTableSettings";

export const defaultDictionaryTableFeatures: DataTableFeatures = {
  enableColumnPinning: false,
  enableColumnVisibility: false,
  enableColumnOrder: false,
  enableSorting: true,
  initialColumnSizes: {
    name: 500,
  },
};
